import React from "react";
import Fragment from "react-dot-fragment";
import styled from "styled-components";
import { Link } from "react-router";
import { Modal } from "react-bootstrap";

const Styled = {};

Styled.Title = styled.h1`
  margin-bottom: 1.5em;
  font-family: Lato;
  font-weight: bold;
  font-size: 20px;
  color: #424242;
`;

Styled.Subtitle = styled.h2`
  margin-bottom: 1.5em;
  font-family: Lato;
  font-weight: bold;
  font-size: 18px;
  color: #424242;
`;

Styled.GreyBold = styled.h3`
  margin-bottom: 1em;
  font-family: Lato;
  font-weight: bold;
  font-size: 16px;
  color: #666666;
`;

Styled.Bold = styled.b`
  color: #073763;
`;

Styled.ResponsiveImage = styled.img`
  max-width: ${p => (p.maxWidth ? p.maxWidth : "100%")}
  margin-left: auto;
  margin-right: auto;
  display: block;
  ${p =>
    p.align &&
    `
    float: ${p.align};
  `}
`;

Styled.ImageDescription = styled.div`
  font-family: Lato;
  font-size: 18px;
  color: #424242;
  text-align: center;
  margin-bottom: 1em;
`;

Styled.UnmarkedList = styled.ol`
  list-style-type: disc;

  li {
    padding-bottom: 1.5em;
  }
`;

Styled.SupDescription = styled.div`
  margin-top: 3em;
  border-top: 1px solid #424242;
  font-size: 14px;
  padding-top: 1em;
`;

Styled.CustomModal = styled(Modal)`
  .custom-modal {
    width: 90vw;
    max-width: 1000px;

    .modal-content {
      font-size: 16px;
      color: #424242;
    }
  }
`;

Styled.ModalTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #000;
    color: #000;
    text-align: center;
    padding: 5px 10px;

    &:first-child {
      text-align: left;
    }
  }

  th {
    text-align: left;
    background-color: #990000;
    color: #fff;
    font-weight: bold !important;
  }

  tr.avg {
    td {
      background-color: #f1c232;
    }
  }

  tr.grey {
    td {
      background-color: #efefef;
      font-weight: bold;
      color: #1c3b6d;
    }
  }
`;

export const LineBreak = ({ count = 2 }) => (
  <Fragment>
    {[...Array(count).keys()].map(i => (
      <br key={i} />
    ))}
  </Fragment>
);

export const Exhibit = ({ number, round }) => (
  <Link to={`/analysis/bcase/modal-exhibit${number}?round=${round}`}>
    Exhibit {number}
  </Link>
);

export const CustomModal = ({ children, goBack }) => (
  <Styled.CustomModal
    dialogClassName="custom-modal"
    show={true}
    onHide={goBack}
  >
    <Modal.Body>{children}</Modal.Body>
  </Styled.CustomModal>
);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/bcase/styles.js